<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          style="cursor:pointer"
        >view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12 print-media">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Advisor/advisordashboard',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
          </div>
          <h3 class="text-blue mt-5">{{trainingDetails.title}}</h3>

          <div class="row mt-5">
            <div class="col-lg-6">
              <h4 class="text-blue">Event Brief Information</h4>
            </div>
            <div class="col-lg-6">
             <button
                class="btn btn-primary text-uppercase btn-report float-right ml-3 "
                 @click="PrintTrainingDetails"
              >Print Details</button>
              <router-link
                :to="{ path: '/dashboard/advisor/analysis-report', query: { trainingId: this.trainingCode}}"
                class="btn btn-primary text-uppercase btn-report float-right"
              >Overall Training Analysis</router-link>
             
            </div>
          </div>

          <div class="row mt-3">
            <div
              class="col-sm-4"
              v-if="trainingDetails != '' && trainingDetails.district != undefined && trainingDetails.district.province != undefined && trainingDetails.district.province.country != undefined"
            >
              <label class="mr-2 font-weight-bold">Country</label>
              {{trainingDetails.district.province.country.title}}
            </div>

            <div
              class="col-sm-4"
              v-if="trainingDetails != '' && trainingDetails.district != undefined && trainingDetails.district.province != undefined"
            >
              <label class="mr-2 font-weight-bold">Province</label>
              {{trainingDetails.district.province.title}}
            </div>

            <div
              class="col-sm-4"
              v-if="trainingDetails != '' && trainingDetails.district != undefined"
            >
              <label class="mr-2 font-weight-bold">City</label>
              {{trainingDetails.district.title}}
            </div>
          </div>

          <div class="row mt-3">
            <div
              class="col-sm-4"
              v-if="trainingDetails != '' && trainingDetails.advisor != undefined"
            >
              <label class="mr-2 font-weight-bold">Advisor</label>
              {{trainingDetails.advisor.name}}
            </div>

            <div
              class="col-sm-4"
              v-if="trainingDetails != '' && trainingDetails.programofficer != undefined"
            >
              <label class="mr-2 font-weight-bold">Program Officer</label>
              {{trainingDetails.programofficer.name}}
            </div>

            <div
              class="col-sm-4"
              v-if="trainingDetails != '' && trainingDetails.subprogram != undefined"
            >
              <label class="mr-2 font-weight-bold">Sub Program / Project</label>
              {{trainingDetails.subprogram.title}}
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4" v-if="doners">
              <label class="mr-2 font-weight-bold">Donor</label>
              <span v-for="(doner,index) in doners" v-bind:key="index">{{doner.title}} ,</span>
            </div>

            <div class="col-sm-8" v-if="alltrainers">
              <label class="mr-2 font-weight-bold">Facilitators</label>
              <span
                v-for="(trainer,trIndex) in alltrainers"
                v-bind:key="trIndex"
              >{{trainer.trainer.name}} ,</span>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Start Date</label>
              {{trainingDetails.startdate}}
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">End Date</label>
              {{trainingDetails.enddate}}
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">No. of Days</label>
              {{trainingDetails.noofdays}}
            </div>
          </div>

          <div class="row mt-5">
                <div class="col-sm-7">
              <h4 class="text-blue">Attendees Information</h4>
            </div>
            <!--
            <div class="col-sm-5">
               <a @click="$bvModal.show('addNewPerson')"
                class="btn btn-primary text-uppercase btn-report float-right ml-3 text-white"
              >Add</a>
            </div>
            -->
            <div class="table-responsive pl-3">
              <table class="table table-borderless mt-3" v-if="allTrainees">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>CNIC</th>
                    <th>Designation</th>
                    <th>Department</th>
                    <th>Username</th>
                    <th>Number</th>
                    <th>Attendance</th>
                  </tr>
                 </thead>
             <!-- </table>
              <table class="table table-borderless mt-3">
                <tbody>-->
                  <h5 class="text-blue pl-2">Participants</h5>
                  <tr v-for="(trainee,tIndex) in allTrainees" v-bind:key="tIndex">
                    <td>{{tIndex+1}}</td>
                    <td
                      v-if="trainee.trainee.userstrainee.name"
                    >{{trainee.trainee.userstrainee.name}}</td>
                    <td v-else>N/A</td>
                    <td v-if="trainee.trainee.cnic">{{trainee.trainee.cnic}}</td>
                    <td v-else>N/A</td>
                    <td v-if="trainee.trainee.designation"> {{getDesignationTitle(trainee.trainee.designation)}}</td>
                    <td v-else>N/A</td>
                    <td v-if="trainee.trainee.department_name"> {{getDepartmentTitle(trainee.trainee.department_name)}}</td>
                    <td v-else>N/A</td>
                    <td
                      v-if="trainee.trainee.userstrainee.username"
                    >{{trainee.trainee.userstrainee.username}}</td>
                    <td v-else>N/A</td>
                    <td
                      v-if="trainee.trainee.userstrainee.contactNo"
                    >{{trainee.trainee.userstrainee.contactNo}}</td>
                    <td v-else>N/A</td>
                    <td>Present</td>
                  </tr>
                
              </table>
              <h5 class="text-blue">UNODC Staff & Facilitators</h5>
              <table class="table table-borderless mt-3">
                <tbody>
                  <tr>
                    <td>1</td>
                    <td v-if="trainingDetails.advisor">{{trainingDetails.advisor.name}}</td>
                    <td v-else>N/A</td>
                    <td>N/A</td>
                    <td>Advisor</td>
                    <td>UNODC</td>
                    <td v-if="trainingDetails.advisor">{{trainingDetails.advisor.username}}</td>
                    <td v-if="trainingDetails.advisor">{{trainingDetails.advisor.contactNo}}</td>
                    <td>Present</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td v-if="trainingDetails.programofficer">{{trainingDetails.programofficer.name}}</td>
                    <td v-else>N/A</td>
                    <td>N/A</td>
                    <td>Program Officer</td>
                    <td>UNODC</td>
                    <td v-if="trainingDetails.programofficer">{{trainingDetails.programofficer.username}}</td>
                    <td v-else>N/A</td>
                    <td v-if="trainingDetails.programofficer">{{trainingDetails.programofficer.contactNo}}</td>
                    <td v-else>N/A</td>
                    <td>Present</td>
                  </tr>
                  <tr v-for="(staff,staffindex) in allStaff" v-bind:key="staffindex">
                    <td>{{staffindex+3}}</td>
                    <td v-if="staff.name">{{staff.name}}</td>
                    <td v-else>N/A</td>
                    <td v-if="staff.cnic">{{staff.cnic}}</td>
                    <td v-else>N/A</td>
                    <td v-if="staff.designation">{{staff.designation}}</td>
                    <td v-else>N/A</td>
                    <td v-if="staff.department">{{staff.department}}</td>
                    <td v-else>N/A</td>
                    <td v-if="staff.email">{{staff.email}}</td>
                    <td v-else>N/A</td>
                    <td v-if="staff.phone">{{staff.phone}}</td>
                    <td v-else>N/A</td>
                    <td>Present</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!--addNewProvince-->
   <b-modal id="addNewPerson" hide-footer hide-header>
      <form @submit.prevent="addstaffMember">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Person)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name</label>
              <input type="text" v-model="ename" class="form-control" placeholder="Enter Name" />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">CNIC</label>
              <input type="text" v-model="ecninc" class="form-control" placeholder="Enter CNIC" />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Designation</label>
              <input
                type="text"
                v-model="edesignation"
                class="form-control"
                placeholder="Enter Designation"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Department</label>
              <input
                type="text"
                v-model="edepartment"
                class="form-control"
                placeholder="Enter Department"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Email</label>
              <input type="text" v-model="eemail" class="form-control" placeholder="Enter Email" />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Phone Number</label>
              <input
                type="text"
                v-model="ephone"
                class="form-control"
                placeholder="Enter Phone Number"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button type="submit" class="mt-3 mr-1 modal-btn" variant="primary">Add</b-button>
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewPerson')"
            >Cancel</b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>


<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";


export default {
  data: () => ({
    isActve1: 1,
    ename: "",
    ecninc: "",
    edesignation: "",
    edepartment: "",
    eemail: "",
    ephone: "",
    etraining_id: "",
    trainingCode: "",
    trainingDetails: [],
    trainingId: "",
    alltrainers: [],
    allTrainees: [],
    doners: [],
     allStaff: [],
    isSidebar: false,
    colorx: "warning",
    traineeDeptArr:[],
    traineeDesigArr:[],
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  created() {},
  methods: {
    addstaffMember(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.ename) {
        this.inValid.push("Name is required.");
      }
      if (!this.ecninc) {
        this.inValid.push("CNIC is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/unodc-staff/add", {
            name: this.ename,
            cnic: this.ecninc,
            designation: this.edesignation,
            department: this.edepartment,
            email: this.eemail,
            phone: this.ephone,
            training_id : this.etraining_id,
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been added successfully!");
              this.$bvModal.hide('addNewPerson')
              self.resetForm();
              this.allStaffMembers(this.etraining_id);
            } 
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    resetForm() {
      this.ename = "";
      this.ecninc = "";
      this.edepartment = "";
      this.edesignation = "";
      this.eemail = "";
      this.ephone = "";
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    showTrainers: function showTrainers(tId) {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/single/training/trainer/get/" +
            tId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.alltrainers = response.data;
        });
    },
    allStaffMembers: function allStaffMembers(tId) {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/single/training/unodc-staff/get/" +
            tId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.allStaff = response.data;
        });
    },
    showTrainees: function showTrainees(tId) {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/single/training/traineedetails/report/get/" +
            tId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.allTrainees = response.data.trainees;
        });
    },
  
   
    PrintTrainingDetails: function() {
      window.print();
    },
     getDesignationTitle(designationId) {
        const match = this.traineeDesigArr.find(
        (item) => item.id == designationId
      );
      return match ? match.title : '';
    },
    getDepartmentTitle(Id) {
        const match = this.traineeDeptArr.find(
        (item) => item.id == Id
      );
      return match ? match.title : '';
    },
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data && response.data.training) {
          this.trainingDetails = response.data.training;
          this.etraining_id = response.data.training.id;
          this.allStaffMembers(response.data.training.id);
          this.showTrainers(response.data.training.id);
          this.showTrainees(response.data.training.id);
        }
        if (response.data && response.data.doner) {
          this.doners = response.data.doner;
        }
      });

       axios
        .get(process.env.VUE_APP_BASE_PATH + "/departments/get"
        )
        .then(response => {
          this.traineeDeptArr = response.data;
        });

       axios
        .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all"
        )
        .then(response => {
          this.traineeDesigArr = response.data;
        });
  }
};
</script>

<style scoped>
.text-blue {
  color: #00a4ea;
}
.btn-report {
  background-color: #6488d2 !important;
  border-radius: 0px !important;
  padding: 3px 30px !important;
}
.table th,
.table td {
  width: 10%;
}
@media print{
  #page-content-wrapper {
     overflow: visible !important;
    height: auto !important;
}
 .btn-report{
   display:none
 }
 .print-media{
   display:none;
 }
}
</style>
